export default ":host {\n  width: 100%;\n}\n:host .header-menu-wrapper {\n  height: 100%;\n}";